import { render, staticRenderFns } from "./CompanyPayment.vue?vue&type=template&id=e715d434"
import script from "./CompanyPayment.vue?vue&type=script&lang=js"
export * from "./CompanyPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports